// extracted by mini-css-extract-plugin
export default {"wrapper":"ManageDocs_wrapper__m3rM7"};